module.exports = __webpack_public_path__ + "img/000.3520ac84.png";